// Auto-generated file. Do not edit.
import { Translatable } from '@/hooks/useTranslator';
import { CountryType } from '@/types/country';

export interface Country {
  readonly value: CountryType;
  readonly label: Translatable;
}

const countries: readonly Country[] = [
  {
    value: CountryType.AX,
    label: {
      en: 'Aland Islands',
      pt: 'Ilhas de Aland',
      es: 'Alandia',
    },
  },
  {
    value: CountryType.DZ,
    label: {
      en: 'Algeria',
      pt: 'Argélia',
      es: 'Argelia',
    },
  },
  {
    value: CountryType.AS,
    label: {
      en: 'American Samoa',
      pt: 'Samoa Americana',
      es: 'Samoa Americana',
    },
  },
  {
    value: CountryType.AD,
    label: {
      en: 'Andorra',
      pt: 'Andorra',
      es: 'Andorra',
    },
  },
  {
    value: CountryType.AO,
    label: {
      en: 'Angola',
      pt: 'Angola',
      es: 'Angola',
    },
  },
  {
    value: CountryType.AI,
    label: {
      en: 'Anguilla',
      pt: 'Anguila',
      es: 'Anguilla',
    },
  },
  {
    value: CountryType.AQ,
    label: {
      en: 'Antarctica',
      pt: 'Antárctida',
      es: 'Antártida',
    },
  },
  {
    value: CountryType.AG,
    label: {
      en: 'Antigua and Barbuda',
      pt: 'Antígua e Barbuda',
      es: 'Antigua y Barbuda',
    },
  },
  {
    value: CountryType.AR,
    label: {
      en: 'Argentina',
      pt: 'Argentina',
      es: 'Argentina',
    },
  },
  {
    value: CountryType.AM,
    label: {
      en: 'Armenia',
      pt: 'Arménia',
      es: 'Armenia',
    },
  },
  {
    value: CountryType.AW,
    label: {
      en: 'Aruba',
      pt: 'Aruba',
      es: 'Aruba',
    },
  },
  {
    value: CountryType.AU,
    label: {
      en: 'Australia',
      pt: 'Austrália',
      es: 'Australia',
    },
  },
  {
    value: CountryType.AT,
    label: {
      en: 'Austria',
      pt: 'áustria',
      es: 'Austria',
    },
  },
  {
    value: CountryType.AZ,
    label: {
      en: 'Azerbaijan',
      pt: 'Azerbaijão',
      es: 'Azerbaiyán',
    },
  },
  {
    value: CountryType.BH,
    label: {
      en: 'Bahrain',
      pt: 'Barém',
      es: 'Bahrein',
    },
  },
  {
    value: CountryType.BD,
    label: {
      en: 'Bangladesh',
      pt: 'Bangladeche',
      es: 'Bangladesh',
    },
  },
  {
    value: CountryType.BB,
    label: {
      en: 'Barbados',
      pt: 'Barbados',
      es: 'Barbados',
    },
  },
  {
    value: CountryType.BE,
    label: {
      en: 'Belgium',
      pt: 'Bélgica',
      es: 'Bélgica',
    },
  },
  {
    value: CountryType.BZ,
    label: {
      en: 'Belize',
      pt: 'Belize',
      es: 'Belice',
    },
  },
  {
    value: CountryType.BJ,
    label: {
      en: 'Benin',
      pt: 'Benim',
      es: 'Benín',
    },
  },
  {
    value: CountryType.BM,
    label: {
      en: 'Bermuda',
      pt: 'Bermudas',
      es: 'Bermudas',
    },
  },
  {
    value: CountryType.BT,
    label: {
      en: 'Bhutan',
      pt: 'Butão',
      es: 'Bután',
    },
  },
  {
    value: CountryType.BO,
    label: {
      en: 'Bolivia',
      pt: 'Bolívia',
      es: 'Bolivia',
    },
  },
  {
    value: CountryType.BQ,
    label: {
      en: 'Bonaire, Sint Eustatius and Saba',
      pt: 'Bonaire',
      es: 'Bonaire, Sint Eustatius and Saba',
    },
  },
  {
    value: CountryType.BA,
    label: {
      en: 'Bosnia and Herzegovina',
      pt: 'Bósnia e Herzegovina',
      es: 'Bosnia y Herzegovina',
    },
  },
  {
    value: CountryType.BW,
    label: {
      en: 'Botswana',
      pt: 'Botsuana',
      es: 'Botswana',
    },
  },
  {
    value: CountryType.BV,
    label: {
      en: 'Bouvet Island',
      pt: 'Ilha Bouvet',
      es: 'Isla Bouvet',
    },
  },
  {
    value: CountryType.BR,
    label: {
      en: 'Brazil',
      pt: 'Brasil',
      es: 'Brasil',
    },
  },
  {
    value: CountryType.IO,
    label: {
      en: 'British Indian Ocean Territory',
      pt: 'Território Britânico do Oceano Índico',
      es: 'Territorio Británico del Océano Índico',
    },
  },
  {
    value: CountryType.BN,
    label: {
      en: 'Brunei',
      pt: 'Brunei',
      es: 'Brunei',
    },
  },
  {
    value: CountryType.BG,
    label: {
      en: 'Bulgaria',
      pt: 'Bulgária',
      es: 'Bulgaria',
    },
  },
  {
    value: CountryType.BF,
    label: {
      en: 'Burkina Faso',
      pt: 'Burquina Faso',
      es: 'Burkina Faso',
    },
  },
  {
    value: CountryType.BI,
    label: {
      en: 'Burundi',
      pt: 'Burúndi',
      es: 'Burundi',
    },
  },
  {
    value: CountryType.KH,
    label: {
      en: 'Cambodia',
      pt: 'Camboja',
      es: 'Camboya',
    },
  },
  {
    value: CountryType.CM,
    label: {
      en: 'Cameroon',
      pt: 'Camarões',
      es: 'Camerún',
    },
  },
  {
    value: CountryType.CA,
    label: {
      en: 'Canada',
      pt: 'Canadá',
      es: 'Canadá',
    },
  },
  {
    value: CountryType.CV,
    label: {
      en: 'Cape Verde',
      pt: 'Cabo Verde',
      es: 'Cabo Verde',
    },
  },
  {
    value: CountryType.KY,
    label: {
      en: 'Cayman Islands',
      pt: 'Ilhas Caimão',
      es: 'Islas Caimán',
    },
  },
  {
    value: CountryType.TD,
    label: {
      en: 'Chad',
      pt: 'Chade',
      es: 'Chad',
    },
  },
  {
    value: CountryType.CL,
    label: {
      en: 'Chile',
      pt: 'Chile',
      es: 'Chile',
    },
  },
  {
    value: CountryType.CN,
    label: {
      en: 'China',
      pt: 'China',
      es: 'China',
    },
  },
  {
    value: CountryType.CX,
    label: {
      en: 'Christmas Island',
      pt: 'Ilha do Natal',
      es: 'Isla de Navidad',
    },
  },
  {
    value: CountryType.CC,
    label: {
      en: 'Cocos (Keeling) Islands',
      pt: 'Ilhas dos Cocos',
      es: 'Islas Cocos o Islas Keeling',
    },
  },
  {
    value: CountryType.CO,
    label: {
      en: 'Colombia',
      pt: 'Colômbia',
      es: 'Colombia',
    },
  },
  {
    value: CountryType.KM,
    label: {
      en: 'Comoros',
      pt: 'Comores',
      es: 'Comoras',
    },
  },
  {
    value: CountryType.CK,
    label: {
      en: 'Cook Islands',
      pt: 'Ilhas Cook',
      es: 'Islas Cook',
    },
  },
  {
    value: CountryType.CR,
    label: {
      en: 'Costa Rica',
      pt: 'Costa Rica',
      es: 'Costa Rica',
    },
  },
  {
    value: CountryType.CI,
    label: {
      en: "Cote D'Ivoire (Ivory Coast)",
      pt: 'Costa do Marfim',
      es: 'Costa de Marfil',
    },
  },
  {
    value: CountryType.HR,
    label: {
      en: 'Croatia',
      pt: 'Croácia',
      es: 'Croacia',
    },
  },
  {
    value: CountryType.CW,
    label: {
      en: 'Curaçao',
      pt: 'Curaçao',
      es: 'Curaçao',
    },
  },
  {
    value: CountryType.CY,
    label: {
      en: 'Cyprus',
      pt: 'Chipre',
      es: 'Chipre',
    },
  },
  {
    value: CountryType.CZ,
    label: {
      en: 'Czech Republic',
      pt: 'República Checa',
      es: 'República Checa',
    },
  },
  {
    value: CountryType.CD,
    label: {
      en: 'Democratic Republic of the Congo',
      pt: 'RD Congo',
      es: 'Congo (Rep. Dem.)',
    },
  },
  {
    value: CountryType.DK,
    label: {
      en: 'Denmark',
      pt: 'Dinamarca',
      es: 'Dinamarca',
    },
  },
  {
    value: CountryType.DJ,
    label: {
      en: 'Djibouti',
      pt: 'Djibuti',
      es: 'Yibuti',
    },
  },
  {
    value: CountryType.DM,
    label: {
      en: 'Dominica',
      pt: 'Dominica',
      es: 'Dominica',
    },
  },
  {
    value: CountryType.DO,
    label: {
      en: 'Dominican Republic',
      pt: 'República Dominicana',
      es: 'República Dominicana',
    },
  },
  {
    value: CountryType.EC,
    label: {
      en: 'Ecuador',
      pt: 'Equador',
      es: 'Ecuador',
    },
  },
  {
    value: CountryType.EG,
    label: {
      en: 'Egypt',
      pt: 'Egipto',
      es: 'Egipto',
    },
  },
  {
    value: CountryType.SV,
    label: {
      en: 'El Salvador',
      pt: 'El Salvador',
      es: 'El Salvador',
    },
  },
  {
    value: CountryType.GQ,
    label: {
      en: 'Equatorial Guinea',
      pt: 'Guiné Equatorial',
      es: 'Guinea Ecuatorial',
    },
  },
  {
    value: CountryType.ER,
    label: {
      en: 'Eritrea',
      pt: 'Eritreia',
      es: 'Eritrea',
    },
  },
  {
    value: CountryType.EE,
    label: {
      en: 'Estonia',
      pt: 'Estónia',
      es: 'Estonia',
    },
  },
  {
    value: CountryType.SZ,
    label: {
      en: 'Eswatini',
      pt: 'Suazilândia',
      es: 'Suazilandia',
    },
  },
  {
    value: CountryType.FK,
    label: {
      en: 'Falkland Islands',
      pt: 'Ilhas Falkland',
      es: 'Islas Malvinas',
    },
  },
  {
    value: CountryType.FO,
    label: {
      en: 'Faroe Islands',
      pt: 'Ilhas Faroé',
      es: 'Islas Faroe',
    },
  },
  {
    value: CountryType.FJ,
    label: {
      en: 'Fiji Islands',
      pt: 'Fiji',
      es: 'Fiyi',
    },
  },
  {
    value: CountryType.FI,
    label: {
      en: 'Finland',
      pt: 'Finlândia',
      es: 'Finlandia',
    },
  },
  {
    value: CountryType.FR,
    label: {
      en: 'France',
      pt: 'França',
      es: 'Francia',
    },
  },
  {
    value: CountryType.GF,
    label: {
      en: 'French Guiana',
      pt: 'Guiana Francesa',
      es: 'Guayana Francesa',
    },
  },
  {
    value: CountryType.PF,
    label: {
      en: 'French Polynesia',
      pt: 'Polinésia Francesa',
      es: 'Polinesia Francesa',
    },
  },
  {
    value: CountryType.TF,
    label: {
      en: 'French Southern Territories',
      pt: 'Terras Austrais e Antárticas Francesas',
      es: 'Tierras Australes y Antárticas Francesas',
    },
  },
  {
    value: CountryType.GA,
    label: {
      en: 'Gabon',
      pt: 'Gabão',
      es: 'Gabón',
    },
  },
  {
    value: CountryType.GE,
    label: {
      en: 'Georgia',
      pt: 'Geórgia',
      es: 'Georgia',
    },
  },
  {
    value: CountryType.DE,
    label: {
      en: 'Germany',
      pt: 'Alemanha',
      es: 'Alemania',
    },
  },
  {
    value: CountryType.GH,
    label: {
      en: 'Ghana',
      pt: 'Gana',
      es: 'Ghana',
    },
  },
  {
    value: CountryType.GI,
    label: {
      en: 'Gibraltar',
      pt: 'Gibraltar',
      es: 'Gibraltar',
    },
  },
  {
    value: CountryType.GR,
    label: {
      en: 'Greece',
      pt: 'Grécia',
      es: 'Grecia',
    },
  },
  {
    value: CountryType.GL,
    label: {
      en: 'Greenland',
      pt: 'Gronelândia',
      es: 'Groenlandia',
    },
  },
  {
    value: CountryType.GD,
    label: {
      en: 'Grenada',
      pt: 'Granada',
      es: 'Grenada',
    },
  },
  {
    value: CountryType.GP,
    label: {
      en: 'Guadeloupe',
      pt: 'Guadalupe',
      es: 'Guadalupe',
    },
  },
  {
    value: CountryType.GU,
    label: {
      en: 'Guam',
      pt: 'Guame',
      es: 'Guam',
    },
  },
  {
    value: CountryType.GT,
    label: {
      en: 'Guatemala',
      pt: 'Guatemala',
      es: 'Guatemala',
    },
  },
  {
    value: CountryType.GG,
    label: {
      en: 'Guernsey and Alderney',
      pt: 'Guernsey',
      es: 'Guernsey',
    },
  },
  {
    value: CountryType.GN,
    label: {
      en: 'Guinea',
      pt: 'Guiné',
      es: 'Guinea',
    },
  },
  {
    value: CountryType.GW,
    label: {
      en: 'Guinea-Bissau',
      pt: 'Guiné-Bissau',
      es: 'Guinea-Bisáu',
    },
  },
  {
    value: CountryType.GY,
    label: {
      en: 'Guyana',
      pt: 'Guiana',
      es: 'Guyana',
    },
  },
  {
    value: CountryType.HT,
    label: {
      en: 'Haiti',
      pt: 'Haiti',
      es: 'Haiti',
    },
  },
  {
    value: CountryType.HM,
    label: {
      en: 'Heard Island and McDonald Islands',
      pt: 'Ilha Heard e Ilhas McDonald',
      es: 'Islas Heard y McDonald',
    },
  },
  {
    value: CountryType.HN,
    label: {
      en: 'Honduras',
      pt: 'Honduras',
      es: 'Honduras',
    },
  },
  {
    value: CountryType.HK,
    label: {
      en: 'Hong Kong S.A.R.',
      pt: 'Hong Kong',
      es: 'Hong Kong',
    },
  },
  {
    value: CountryType.HU,
    label: {
      en: 'Hungary',
      pt: 'Hungria',
      es: 'Hungría',
    },
  },
  {
    value: CountryType.IS,
    label: {
      en: 'Iceland',
      pt: 'Islândia',
      es: 'Islandia',
    },
  },
  {
    value: CountryType.IN,
    label: {
      en: 'India',
      pt: 'Índia',
      es: 'India',
    },
  },
  {
    value: CountryType.ID,
    label: {
      en: 'Indonesia',
      pt: 'Indonésia',
      es: 'Indonesia',
    },
  },
  {
    value: CountryType.IQ,
    label: {
      en: 'Iraq',
      pt: 'Iraque',
      es: 'Irak',
    },
  },
  {
    value: CountryType.IE,
    label: {
      en: 'Ireland',
      pt: 'Irlanda',
      es: 'Irlanda',
    },
  },
  {
    value: CountryType.IL,
    label: {
      en: 'Israel',
      pt: 'Israel',
      es: 'Israel',
    },
  },
  {
    value: CountryType.IT,
    label: {
      en: 'Italy',
      pt: 'Itália',
      es: 'Italia',
    },
  },
  {
    value: CountryType.JM,
    label: {
      en: 'Jamaica',
      pt: 'Jamaica',
      es: 'Jamaica',
    },
  },
  {
    value: CountryType.JP,
    label: {
      en: 'Japan',
      pt: 'Japão',
      es: 'Japón',
    },
  },
  {
    value: CountryType.JE,
    label: {
      en: 'Jersey',
      pt: 'Jersey',
      es: 'Jersey',
    },
  },
  {
    value: CountryType.JO,
    label: {
      en: 'Jordan',
      pt: 'Jordânia',
      es: 'Jordania',
    },
  },
  {
    value: CountryType.KZ,
    label: {
      en: 'Kazakhstan',
      pt: 'Cazaquistão',
      es: 'Kazajistán',
    },
  },
  {
    value: CountryType.KE,
    label: {
      en: 'Kenya',
      pt: 'Quénia',
      es: 'Kenia',
    },
  },
  {
    value: CountryType.KI,
    label: {
      en: 'Kiribati',
      pt: 'Quiribáti',
      es: 'Kiribati',
    },
  },
  {
    value: CountryType.KW,
    label: {
      en: 'Kuwait',
      pt: 'Kuwait',
      es: 'Kuwait',
    },
  },
  {
    value: CountryType.KG,
    label: {
      en: 'Kyrgyzstan',
      pt: 'Quirguizistão',
      es: 'Kirguizistán',
    },
  },
  {
    value: CountryType.LA,
    label: {
      en: 'Laos',
      pt: 'Laos',
      es: 'Laos',
    },
  },
  {
    value: CountryType.LV,
    label: {
      en: 'Latvia',
      pt: 'Letónia',
      es: 'Letonia',
    },
  },
  {
    value: CountryType.LS,
    label: {
      en: 'Lesotho',
      pt: 'Lesoto',
      es: 'Lesotho',
    },
  },
  {
    value: CountryType.LR,
    label: {
      en: 'Liberia',
      pt: 'Libéria',
      es: 'Liberia',
    },
  },
  {
    value: CountryType.LI,
    label: {
      en: 'Liechtenstein',
      pt: 'Listenstaine',
      es: 'Liechtenstein',
    },
  },
  {
    value: CountryType.LT,
    label: {
      en: 'Lithuania',
      pt: 'Lituânia',
      es: 'Lituania',
    },
  },
  {
    value: CountryType.LU,
    label: {
      en: 'Luxembourg',
      pt: 'Luxemburgo',
      es: 'Luxemburgo',
    },
  },
  {
    value: CountryType.MO,
    label: {
      en: 'Macau S.A.R.',
      pt: 'Macau',
      es: 'Macao',
    },
  },
  {
    value: CountryType.MG,
    label: {
      en: 'Madagascar',
      pt: 'Madagáscar',
      es: 'Madagascar',
    },
  },
  {
    value: CountryType.MW,
    label: {
      en: 'Malawi',
      pt: 'Malávi',
      es: 'Malawi',
    },
  },
  {
    value: CountryType.MY,
    label: {
      en: 'Malaysia',
      pt: 'Malásia',
      es: 'Malasia',
    },
  },
  {
    value: CountryType.MV,
    label: {
      en: 'Maldives',
      pt: 'Maldivas',
      es: 'Maldivas',
    },
  },
  {
    value: CountryType.MT,
    label: {
      en: 'Malta',
      pt: 'Malta',
      es: 'Malta',
    },
  },
  {
    value: CountryType.IM,
    label: {
      en: 'Man (Isle of)',
      pt: 'Ilha de Man',
      es: 'Isla de Man',
    },
  },
  {
    value: CountryType.MH,
    label: {
      en: 'Marshall Islands',
      pt: 'Ilhas Marshall',
      es: 'Islas Marshall',
    },
  },
  {
    value: CountryType.MQ,
    label: {
      en: 'Martinique',
      pt: 'Martinica',
      es: 'Martinica',
    },
  },
  {
    value: CountryType.MR,
    label: {
      en: 'Mauritania',
      pt: 'Mauritânia',
      es: 'Mauritania',
    },
  },
  {
    value: CountryType.MU,
    label: {
      en: 'Mauritius',
      pt: 'Maurícia',
      es: 'Mauricio',
    },
  },
  {
    value: CountryType.YT,
    label: {
      en: 'Mayotte',
      pt: 'Mayotte',
      es: 'Mayotte',
    },
  },
  {
    value: CountryType.MX,
    label: {
      en: 'Mexico',
      pt: 'México',
      es: 'México',
    },
  },
  {
    value: CountryType.FM,
    label: {
      en: 'Micronesia',
      pt: 'Micronésia',
      es: 'Micronesia',
    },
  },
  {
    value: CountryType.MD,
    label: {
      en: 'Moldova',
      pt: 'Moldávia',
      es: 'Moldavia',
    },
  },
  {
    value: CountryType.MC,
    label: {
      en: 'Monaco',
      pt: 'Mónaco',
      es: 'Mónaco',
    },
  },
  {
    value: CountryType.MN,
    label: {
      en: 'Mongolia',
      pt: 'Mongólia',
      es: 'Mongolia',
    },
  },
  {
    value: CountryType.ME,
    label: {
      en: 'Montenegro',
      pt: 'Montenegro',
      es: 'Montenegro',
    },
  },
  {
    value: CountryType.MS,
    label: {
      en: 'Montserrat',
      pt: 'Monserrate',
      es: 'Montserrat',
    },
  },
  {
    value: CountryType.MA,
    label: {
      en: 'Morocco',
      pt: 'Marrocos',
      es: 'Marruecos',
    },
  },
  {
    value: CountryType.MZ,
    label: {
      en: 'Mozambique',
      pt: 'Moçambique',
      es: 'Mozambique',
    },
  },
  {
    value: CountryType.NA,
    label: {
      en: 'Namibia',
      pt: 'Namíbia',
      es: 'Namibia',
    },
  },
  {
    value: CountryType.NR,
    label: {
      en: 'Nauru',
      pt: 'Nauru',
      es: 'Nauru',
    },
  },
  {
    value: CountryType.NP,
    label: {
      en: 'Nepal',
      pt: 'Nepal',
      es: 'Nepal',
    },
  },
  {
    value: CountryType.NL,
    label: {
      en: 'Netherlands',
      pt: 'Países Baixos',
      es: 'Países Bajos',
    },
  },
  {
    value: CountryType.NC,
    label: {
      en: 'New Caledonia',
      pt: 'Nova Caledónia',
      es: 'Nueva Caledonia',
    },
  },
  {
    value: CountryType.NZ,
    label: {
      en: 'New Zealand',
      pt: 'Nova Zelândia',
      es: 'Nueva Zelanda',
    },
  },
  {
    value: CountryType.NE,
    label: {
      en: 'Niger',
      pt: 'Níger',
      es: 'Níger',
    },
  },
  {
    value: CountryType.NG,
    label: {
      en: 'Nigeria',
      pt: 'Nigéria',
      es: 'Nigeria',
    },
  },
  {
    value: CountryType.NU,
    label: {
      en: 'Niue',
      pt: 'Niue',
      es: 'Niue',
    },
  },
  {
    value: CountryType.NF,
    label: {
      en: 'Norfolk Island',
      pt: 'Ilha Norfolk',
      es: 'Isla de Norfolk',
    },
  },
  {
    value: CountryType.MP,
    label: {
      en: 'Northern Mariana Islands',
      pt: 'Ilhas Marianas',
      es: 'Islas Marianas del Norte',
    },
  },
  {
    value: CountryType.NO,
    label: {
      en: 'Norway',
      pt: 'Noruega',
      es: 'Noruega',
    },
  },
  {
    value: CountryType.OM,
    label: {
      en: 'Oman',
      pt: 'Omã',
      es: 'Omán',
    },
  },
  {
    value: CountryType.PK,
    label: {
      en: 'Pakistan',
      pt: 'Paquistão',
      es: 'Pakistán',
    },
  },
  {
    value: CountryType.PW,
    label: {
      en: 'Palau',
      pt: 'Palau',
      es: 'Palau',
    },
  },
  {
    value: CountryType.PS,
    label: {
      en: 'Palestinian Territory Occupied',
      pt: 'Palestina',
      es: 'Palestina',
    },
  },
  {
    value: CountryType.PA,
    label: {
      en: 'Panama',
      pt: 'Panamá',
      es: 'Panamá',
    },
  },
  {
    value: CountryType.PG,
    label: {
      en: 'Papua New Guinea',
      pt: 'Papua Nova Guiné',
      es: 'Papúa Nueva Guinea',
    },
  },
  {
    value: CountryType.PY,
    label: {
      en: 'Paraguay',
      pt: 'Paraguai',
      es: 'Paraguay',
    },
  },
  {
    value: CountryType.PE,
    label: {
      en: 'Peru',
      pt: 'Peru',
      es: 'Perú',
    },
  },
  {
    value: CountryType.PH,
    label: {
      en: 'Philippines',
      pt: 'Filipinas',
      es: 'Filipinas',
    },
  },
  {
    value: CountryType.PN,
    label: {
      en: 'Pitcairn Island',
      pt: 'Ilhas Picárnia',
      es: 'Islas Pitcairn',
    },
  },
  {
    value: CountryType.PL,
    label: {
      en: 'Poland',
      pt: 'Polónia',
      es: 'Polonia',
    },
  },
  {
    value: CountryType.PT,
    label: {
      en: 'Portugal',
      pt: 'Portugal',
      es: 'Portugal',
    },
  },
  {
    value: CountryType.PR,
    label: {
      en: 'Puerto Rico',
      pt: 'Porto Rico',
      es: 'Puerto Rico',
    },
  },
  {
    value: CountryType.QA,
    label: {
      en: 'Qatar',
      pt: 'Catar',
      es: 'Catar',
    },
  },
  {
    value: CountryType.RE,
    label: {
      en: 'Reunion',
      pt: 'Reunião',
      es: 'Reunión',
    },
  },
  {
    value: CountryType.RU,
    label: {
      en: 'Russia',
      pt: 'Rússia',
      es: 'Rusia',
    },
  },
  {
    value: CountryType.RW,
    label: {
      en: 'Rwanda',
      pt: 'Ruanda',
      es: 'Ruanda',
    },
  },
  {
    value: CountryType.SH,
    label: {
      en: 'Saint Helena',
      pt: 'Santa Helena',
      es: 'Santa Helena',
    },
  },
  {
    value: CountryType.KN,
    label: {
      en: 'Saint Kitts and Nevis',
      pt: 'São Cristóvão e Neves',
      es: 'San Cristóbal y Nieves',
    },
  },
  {
    value: CountryType.LC,
    label: {
      en: 'Saint Lucia',
      pt: 'Santa Lúcia',
      es: 'Santa Lucía',
    },
  },
  {
    value: CountryType.PM,
    label: {
      en: 'Saint Pierre and Miquelon',
      pt: 'São Pedro e Miquelon',
      es: 'San Pedro y Miquelón',
    },
  },
  {
    value: CountryType.VC,
    label: {
      en: 'Saint Vincent and the Grenadines',
      pt: 'São Vicente e Granadinas',
      es: 'San Vicente y Granadinas',
    },
  },
  {
    value: CountryType.BL,
    label: {
      en: 'Saint-Barthelemy',
      pt: 'São Bartolomeu',
      es: 'San Bartolomé',
    },
  },
  {
    value: CountryType.MF,
    label: {
      en: 'Saint-Martin (French part)',
      pt: 'Ilha São Martinho',
      es: 'Saint Martin',
    },
  },
  {
    value: CountryType.WS,
    label: {
      en: 'Samoa',
      pt: 'Samoa',
      es: 'Samoa',
    },
  },
  {
    value: CountryType.SM,
    label: {
      en: 'San Marino',
      pt: 'São Marinho',
      es: 'San Marino',
    },
  },
  {
    value: CountryType.ST,
    label: {
      en: 'Sao Tome and Principe',
      pt: 'São Tomé e Príncipe',
      es: 'Santo Tomé y Príncipe',
    },
  },
  {
    value: CountryType.SA,
    label: {
      en: 'Saudi Arabia',
      pt: 'Arábia Saudita',
      es: 'Arabia Saudí',
    },
  },
  {
    value: CountryType.SN,
    label: {
      en: 'Senegal',
      pt: 'Senegal',
      es: 'Senegal',
    },
  },
  {
    value: CountryType.SC,
    label: {
      en: 'Seychelles',
      pt: 'Seicheles',
      es: 'Seychelles',
    },
  },
  {
    value: CountryType.SL,
    label: {
      en: 'Sierra Leone',
      pt: 'Serra Leoa',
      es: 'Sierra Leone',
    },
  },
  {
    value: CountryType.SG,
    label: {
      en: 'Singapore',
      pt: 'Singapura',
      es: 'Singapur',
    },
  },
  {
    value: CountryType.SX,
    label: {
      en: 'Sint Maarten (Dutch part)',
      pt: 'São Martinho',
      es: 'Sint Maarten (Dutch part)',
    },
  },
  {
    value: CountryType.SK,
    label: {
      en: 'Slovakia',
      pt: 'Eslováquia',
      es: 'República Eslovaca',
    },
  },
  {
    value: CountryType.SI,
    label: {
      en: 'Slovenia',
      pt: 'Eslovénia',
      es: 'Eslovenia',
    },
  },
  {
    value: CountryType.SB,
    label: {
      en: 'Solomon Islands',
      pt: 'Ilhas Salomão',
      es: 'Islas Salomón',
    },
  },
  {
    value: CountryType.SO,
    label: {
      en: 'Somalia',
      pt: 'Somália',
      es: 'Somalia',
    },
  },
  {
    value: CountryType.ZA,
    label: {
      en: 'South Africa',
      pt: 'República Sul-Africana',
      es: 'República de Sudáfrica',
    },
  },
  {
    value: CountryType.GS,
    label: {
      en: 'South Georgia',
      pt: 'Ilhas Geórgia do Sul e Sanduíche do Sul',
      es: 'Islas Georgias del Sur y Sandwich del Sur',
    },
  },
  {
    value: CountryType.KR,
    label: {
      en: 'South Korea',
      pt: 'Coreia do Sul',
      es: 'Corea del Sur',
    },
  },
  {
    value: CountryType.ES,
    label: {
      en: 'Spain',
      pt: 'Espanha',
      es: 'España',
    },
  },
  {
    value: CountryType.LK,
    label: {
      en: 'Sri Lanka',
      pt: 'Sri Lanka',
      es: 'Sri Lanka',
    },
  },
  {
    value: CountryType.SR,
    label: {
      en: 'Suriname',
      pt: 'Suriname',
      es: 'Surinam',
    },
  },
  {
    value: CountryType.SJ,
    label: {
      en: 'Svalbard and Jan Mayen Islands',
      pt: 'Svalbard',
      es: 'Islas Svalbard y Jan Mayen',
    },
  },
  {
    value: CountryType.SE,
    label: {
      en: 'Sweden',
      pt: 'Suécia',
      es: 'Suecia',
    },
  },
  {
    value: CountryType.CH,
    label: {
      en: 'Switzerland',
      pt: 'Suíça',
      es: 'Suiza',
    },
  },
  {
    value: CountryType.TW,
    label: {
      en: 'Taiwan',
      pt: 'Taiwan',
      es: 'Taiwán',
    },
  },
  {
    value: CountryType.TJ,
    label: {
      en: 'Tajikistan',
      pt: 'Tajiquistão',
      es: 'Tayikistán',
    },
  },
  {
    value: CountryType.TZ,
    label: {
      en: 'Tanzania',
      pt: 'Tanzânia',
      es: 'Tanzania',
    },
  },
  {
    value: CountryType.TH,
    label: {
      en: 'Thailand',
      pt: 'Tailândia',
      es: 'Tailandia',
    },
  },
  {
    value: CountryType.BS,
    label: {
      en: 'The Bahamas',
      pt: 'Baamas',
      es: 'Bahamas',
    },
  },
  {
    value: CountryType.GM,
    label: {
      en: 'The Gambia ',
      pt: 'Gâmbia',
      es: 'Gambia',
    },
  },
  {
    value: CountryType.TL,
    label: {
      en: 'Timor-Leste',
      pt: 'Timor Leste',
      es: 'Timor Oriental',
    },
  },
  {
    value: CountryType.TG,
    label: {
      en: 'Togo',
      pt: 'Togo',
      es: 'Togo',
    },
  },
  {
    value: CountryType.TK,
    label: {
      en: 'Tokelau',
      pt: 'Toquelau',
      es: 'Islas Tokelau',
    },
  },
  {
    value: CountryType.TO,
    label: {
      en: 'Tonga',
      pt: 'Tonga',
      es: 'Tonga',
    },
  },
  {
    value: CountryType.TT,
    label: {
      en: 'Trinidad and Tobago',
      pt: 'Trindade e Tobago',
      es: 'Trinidad y Tobago',
    },
  },
  {
    value: CountryType.TN,
    label: {
      en: 'Tunisia',
      pt: 'Tunísia',
      es: 'Túnez',
    },
  },
  {
    value: CountryType.TR,
    label: {
      en: 'Turkey',
      pt: 'Turquia',
      es: 'Turquía',
    },
  },
  {
    value: CountryType.TM,
    label: {
      en: 'Turkmenistan',
      pt: 'Turquemenistão',
      es: 'Turkmenistán',
    },
  },
  {
    value: CountryType.TC,
    label: {
      en: 'Turks and Caicos Islands',
      pt: 'Ilhas Turcas e Caicos',
      es: 'Islas Turks y Caicos',
    },
  },
  {
    value: CountryType.TV,
    label: {
      en: 'Tuvalu',
      pt: 'Tuvalu',
      es: 'Tuvalu',
    },
  },
  {
    value: CountryType.UG,
    label: {
      en: 'Uganda',
      pt: 'Uganda',
      es: 'Uganda',
    },
  },
  {
    value: CountryType.AE,
    label: {
      en: 'United Arab Emirates',
      pt: 'Emirados árabes Unidos',
      es: 'Emiratos Árabes Unidos',
    },
  },
  {
    value: CountryType.GB,
    label: {
      en: 'United Kingdom',
      pt: 'Reino Unido',
      es: 'Reino Unido',
    },
  },
  {
    value: CountryType.US,
    label: {
      en: 'United States',
      pt: 'Estados Unidos',
      es: 'Estados Unidos',
    },
  },
  {
    value: CountryType.UM,
    label: {
      en: 'United States Minor Outlying Islands',
      pt: 'Ilhas Menores Distantes dos Estados Unidos',
      es: 'Islas Ultramarinas Menores de Estados Unidos',
    },
  },
  {
    value: CountryType.UY,
    label: {
      en: 'Uruguay',
      pt: 'Uruguai',
      es: 'Uruguay',
    },
  },
  {
    value: CountryType.UZ,
    label: {
      en: 'Uzbekistan',
      pt: 'Usbequistão',
      es: 'Uzbekistán',
    },
  },
  {
    value: CountryType.VU,
    label: {
      en: 'Vanuatu',
      pt: 'Vanuatu',
      es: 'Vanuatu',
    },
  },
  {
    value: CountryType.VA,
    label: {
      en: 'Vatican City State (Holy See)',
      pt: 'Vaticano',
      es: 'Santa Sede',
    },
  },
  {
    value: CountryType.VN,
    label: {
      en: 'Vietnam',
      pt: 'Vietname',
      es: 'Vietnam',
    },
  },
  {
    value: CountryType.VG,
    label: {
      en: 'Virgin Islands (British)',
      pt: 'Ilhas Virgens Britânicas',
      es: 'Islas Vírgenes del Reino Unido',
    },
  },
  {
    value: CountryType.VI,
    label: {
      en: 'Virgin Islands (US)',
      pt: 'Ilhas Virgens Americanas',
      es: 'Islas Vírgenes de los Estados Unidos',
    },
  },
  {
    value: CountryType.WF,
    label: {
      en: 'Wallis and Futuna Islands',
      pt: 'Wallis e Futuna',
      es: 'Wallis y Futuna',
    },
  },
  {
    value: CountryType.EH,
    label: {
      en: 'Western Sahara',
      pt: 'Saara Ocidental',
      es: 'Sahara Occidental',
    },
  },
  {
    value: CountryType.ZM,
    label: {
      en: 'Zambia',
      pt: 'Zâmbia',
      es: 'Zambia',
    },
  },
  {
    value: CountryType.ZW,
    label: {
      en: 'Zimbabwe',
      pt: 'Zimbabué',
      es: 'Zimbabue',
    },
  },
];

export default countries;
